import { v4 as uuidv4 } from 'uuid';

function sukunS() {
  return [
    {
      name: 'The Way of The Tears',
      artist: 'Muhammad Al Muqit',
      cover: 'https://i1.sndcdn.com/artworks-000524208432-aownku-t500x500.jpg',
      id: uuidv4(),
      active: true,
      color: ['#1B4462', '#030C1D'],
      audio:
        'https://www.islamicdb.com/downloads/The%20Way%20of%20The%20Tears%20Muhammad%20al%20Muqit.mp3',
    },
    {
      name: 'I Rise',
      artist: 'Muhammad Al Muqit',
      cover: 'https://i1.sndcdn.com/artworks-000196297064-q6rxcl-t500x500.jpg',
      id: uuidv4(),
      active: false,
      color: ['#BBE5EE', '#02789C'],
      audio:
        'https://thedigitalislam.com/wp-content/uploads/2019/07/%D8%A3%D8%B3%D9%85%D9%88-%D9%85%D8%AD%D9%85%D8%AF-%D8%A7%D9%84%D9%85%D9%82%D9%8A%D8%B7-2016-Muhammad-Al-Muqit.mp3',
    },
    {
      name: 'Habeeb',
      artist: 'Mishary Rashid Al-Afasy',
      cover:
        'https://static10.tgstat.ru/channels/_0/ed/ed468e0b9a166ae8ad0f3bc75f46d173.jpg',
      id: uuidv4(),
      active: false,
      color: ['#282635', '#CFC3B5'],
      audio:
        'https://www.islamicdb.com/downloads/Nasheed%20Habeeb%20Mishary%20Rashid%20al%20Afasi.mp3',
    },
    {
      name: 'Seeds of Morals',
      artist: 'Muhammad Al Muqit',
      cover: 'https://i1.sndcdn.com/artworks-000088738160-bcyd7p-t500x500.jpg',
      id: uuidv4(),
      active: false,
      color: ['#DB537B', '#309B81'],
      audio:
        'https://thedigitalislam.com/wp-content/uploads/2019/07/Ghiras-al-Akhlaqi-%D8%BA%D8%B1%D8%A7%D8%B3-%D8%A7%D9%84%D8%A3%D8%AE%D9%84%D8%A7%D9%82-%D9%85%D8%AD%D9%85%D8%AF-%D8%A7%D9%84%D9%85%D9%82%D9%8A%D8%B7-Muhammad-al-Muqit.mp3',
    },
    {
      name: 'Taweel Alshawq',
      artist: 'Ahmed Bukhatir',
      cover: 'https://i1.sndcdn.com/artworks-000050323384-98lwbw-t500x500.jpg',
      id: uuidv4(),
      active: false,
      color: ['#AA9659', '#565541'],
      audio:
        'https://thedigitalislam.com/wp-content/uploads/2019/07/Taweel-Alshawq-Ahmed-Bukhatir-%D8%A3%D8%AD%D9%85%D8%AF-%D8%A8%D9%88%D8%AE%D8%A7%D8%B7%D8%B1-%D8%B7%D9%88%D9%8A%D9%84-%D8%A7%D9%84%D8%B4%D9%88%D9%82-Arabic-Music-Video.mp3',
    },
    {
      name: 'The Loyality',
      artist: 'Muhammad Al Muqit',
      cover: 'https://i1.sndcdn.com/artworks-000116040225-99owmw-t500x500.jpg',
      id: uuidv4(),
      active: false,
      color: ['#0D330C', '#AFBAB6'],
      audio:
        'https://thedigitalislam.com/wp-content/uploads/2019/07/Al-Wafa-Eng-Subs-%D8%A7%D9%84%D9%88%D9%81%D8%A7%D8%A1-%D9%85%D8%AD%D9%85%D8%AF-%D8%A7%D9%84%D9%85%D9%82%D9%8A%D8%B7-Muhammad-al-Muqit.mp3',
    },
    {
      name: 'Oh Most Magnificent!',
      artist: 'Ahmed Bukhatir',
      cover: 'https://i1.sndcdn.com/artworks-000050324688-918iaf-t500x500.jpg',
      id: uuidv4(),
      active: false,
      color: ['#A54434', '#4D2E2B'],
      audio:
        'https://thedigitalislam.com/wp-content/uploads/2019/07/Nasheed-Ya-Adheeman-Ahmed-Bukhatir-%D9%86%D8%B4%D9%8A%D8%AF-%D9%8A%D8%A7-%D8%B9%D8%B8%D9%8A%D9%85%D8%A7-%D8%A3%D8%AD%D9%85%D8%AF-%D8%A8%D9%88%D8%AE%D8%A7%D8%B7%D8%B1-Arabic-Music-Video.mp3',
    },
    {
      name: 'Fartaqi',
      artist: 'Ahmed Bukhatir',
      cover: 'https://i1.sndcdn.com/artworks-000050324688-918iaf-t500x500.jpg',
      id: uuidv4(),
      active: false,
      color: ['#A54434', '#4D2E2B'],
      audio: 'https://www.a2youth.com/media/audio/21/fartaqi.fartaqi.mp3',
    },
    {
      name: 'Zayed Al-Wafaa',
      artist: 'Ahmed Bukhatir',
      cover: 'https://i1.sndcdn.com/artworks-000050324688-918iaf-t500x500.jpg',
      id: uuidv4(),
      active: false,
      color: ['#A54434', '#4D2E2B'],
      audio:
        'https://www.a2youth.com/media/audio/21/alqodsotonadeena.zayedalwafaa.mp3',
    },
    {
      name: 'Kitaab Allah',
      artist: 'Ahmed Bukhatir',
      cover: 'https://i1.sndcdn.com/artworks-000050324688-918iaf-t500x500.jpg',
      id: uuidv4(),
      active: false,
      color: ['#A54434', '#4D2E2B'],
      audio: 'https://www.a2youth.com/media/audio/21/fartaqi.ketaaballah.mp3',
    },
    {
      name: 'Mawlaya',
      artist: 'Ahmed Bukhatir',
      cover: 'https://i1.sndcdn.com/artworks-000050324688-918iaf-t500x500.jpg',
      id: uuidv4(),
      active: false,
      color: ['#A54434', '#4D2E2B'],
      audio:
        'https://www.a2youth.com/media/audio/21/alqodsotonadeena.mawlaya.mp3',
    },
    {
      name: 'Be Raaheen',
      artist: 'Mishary Rashid Al-Afasy',
      cover:
        'https://static10.tgstat.ru/channels/_0/ed/ed468e0b9a166ae8ad0f3bc75f46d173.jpg',
      id: uuidv4(),
      active: false,
      color: ['#121218', '#CFC3B5'],
      audio:
        'https://www.a2youth.com/media/audio/23/uyoonalafaaee.beraaheen.mp3',
    },
  ];
}

export default sukunS;
